let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("bzHl5")).then(() => parcelRequire('hpPu5'));